module.exports = __webpack_public_path__ + "img/nushko.09a17be2.jpg";